"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformLinear = void 0;
const transformLinear = (minInput, maxInput, minOutput, maxOutput, inputValue) => {
    const inputBetween0And1 = (inputValue - minInput) / (maxInput - minInput);
    return minOutput + (inputBetween0And1 * (maxOutput - minOutput));
};
exports.transformLinear = transformLinear;
